import ProductAttributesBuilder from "./ProductAttributesBuilder";
import Separator from "@/app/components/lib/Separator";
import { fillSelectedAttributes } from "./helpers/functions";
import type { IAttiribs, IProductMinimizedData } from "./helpers/interfaces";

const AttributesStepsSelector: React.FC<
  IProductMinimizedData & {
    selectedAttributes: IAttiribs;
    handleAttributesChanged: any;
    unAvailableKeys: IAttiribs;
    outOfStockKeys: IAttiribs;
    currentAttributeToSelectIdx: number;
    setCurrentAttributeToSelectIdx: React.Dispatch<
      React.SetStateAction<number>
    >;
    attributesMaxWidth?: number;
    allow_user_request_stock_availability_reminder?: boolean;
  }
> = ({
  attributes_builder,
  children,
  handleAttributesChanged,
  selectedAttributes,
  unAvailableKeys,
  outOfStockKeys,
  currentAttributeToSelectIdx,
  setCurrentAttributeToSelectIdx,
  attributesMaxWidth,
  allow_user_request_stock_availability_reminder,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {attributes_builder
        .filter((_, idx) => idx < currentAttributeToSelectIdx)
        .map((attr, idx) => (
          <div key={attr.configurations.key}>
            {attr?.data?.length && attr?.data?.length! > 1 && (
              <Separator
                startLabel={attr.configurations.title}
                marginBottom={8}
              />
            )}
            <ProductAttributesBuilder
              attributesMaxWidth={attributesMaxWidth}
              state={selectedAttributes[attr.configurations.key] || []}
              setState={(state, fromEffect = false) => {
                handleAttributesChanged(
                  attr.configurations.key,
                  state,
                  true,
                  true,
                );
                if (!fromEffect) {
                  setCurrentAttributeToSelectIdx(idx + 1);
                }
              }}
              productChildren={children}
              attribute={attr}
              unAvailabeKeys={unAvailableKeys[attr.configurations.key] || []}
              outOfStockKeys={outOfStockKeys[attr.configurations.key] || []}
            />
          </div>
        ))}
      {currentAttributeToSelectIdx < attributes_builder.length &&
        attributes_builder[currentAttributeToSelectIdx]?.data?.length! > 1 && (
          <>
            <Separator
              startLabel={
                attributes_builder[currentAttributeToSelectIdx].configurations
                  .title
              }
              marginBottom={8}
            />
            <ProductAttributesBuilder
              attributesMaxWidth={attributesMaxWidth}
              state={
                selectedAttributes[
                  attributes_builder[currentAttributeToSelectIdx].configurations
                    .key
                ] || []
              }
              setState={(attrs) => {
                const { currentIndex } = fillSelectedAttributes(
                  attributes_builder,
                  currentAttributeToSelectIdx + 1,
                  unAvailableKeys,
                  outOfStockKeys,
                );
                setCurrentAttributeToSelectIdx(currentIndex);
                handleAttributesChanged(
                  attributes_builder[currentAttributeToSelectIdx].configurations
                    .key,
                  attrs,
                );
              }}
              productChildren={children}
              attribute={attributes_builder[currentAttributeToSelectIdx]}
              unAvailabeKeys={
                unAvailableKeys[
                  attributes_builder[currentAttributeToSelectIdx].configurations
                    .key
                ] || []
              }
              outOfStockKeys={
                outOfStockKeys[
                  attributes_builder[currentAttributeToSelectIdx].configurations
                    .key
                ] || []
              }
              allow_user_request_stock_availability_reminder={
                allow_user_request_stock_availability_reminder
              }
            />
          </>
        )}
    </div>
  );
};

export default AttributesStepsSelector;
